/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseCommentReply } from './BaseCommentReply';
const DeletedCommentReplyParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['deleted', /* #__PURE__ */ parsers.exactly(true)],
]), BaseCommentReply);
export class DeletedCommentReply extends BaseCommentReply {
    static decode(input) {
        return DeletedCommentReplyParser.decode(input).map(res => new DeletedCommentReply(res));
    }
    static unsafeDecode(input) {
        return DeletedCommentReply.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return DeletedCommentReplyParser.encode(data);
    }
    static schema() {
        return DeletedCommentReplyParser.schema();
    }
}
